import { render, staticRenderFns } from "./ViewLoader.vue?vue&type=template&id=371fd342&"
import script from "./ViewLoader.vue?vue&type=script&lang=ts&"
export * from "./ViewLoader.vue?vue&type=script&lang=ts&"
import style0 from "./ViewLoader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports